"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.validateWalletInit = exports.validateSetChainOptions = exports.validateString = exports.validateWalletModule = exports.validateInitOptions = exports.validateWallet = void 0;
var joi_1 = __importDefault(require("joi"));
var onboard_common_1 = require("@sovryn/onboard-common");
var unknownObject = joi_1["default"].object().unknown();
var connectedChain = joi_1["default"].object({
    namespace: onboard_common_1.chainNamespaceValidation.required(),
    id: onboard_common_1.chainIdValidation.required()
});
var ens = joi_1["default"].any().allow(joi_1["default"].object({
    name: joi_1["default"].string().required(),
    avatar: joi_1["default"].string(),
    contentHash: joi_1["default"].any().allow(joi_1["default"].string(), null),
    getText: joi_1["default"]["function"]().arity(1).required()
}), null);
var balance = joi_1["default"].any().allow(joi_1["default"].object({
    eth: joi_1["default"].number()
}).unknown(), null);
var account = joi_1["default"].object({
    address: joi_1["default"].string().required(),
    ens: ens,
    balance: balance
});
var chains = joi_1["default"].array().items(onboard_common_1.chainValidation);
var accounts = joi_1["default"].array().items(account);
var wallet = joi_1["default"].object({
    label: joi_1["default"].string(),
    icon: joi_1["default"].string(),
    provider: unknownObject,
    instance: unknownObject,
    accounts: accounts,
    chains: joi_1["default"].array().items(connectedChain)
}).required();
var walletModule = joi_1["default"].object({
    label: joi_1["default"].string().required(),
    getInfo: joi_1["default"]["function"]().arity(1).required(),
    getInterface: joi_1["default"]["function"]().arity(1).required()
});
var walletInit = joi_1["default"].array().items(joi_1["default"]["function"]()).required();
var initOptions = joi_1["default"].object({
    wallets: walletInit,
    chains: chains.required(),
    i18n: joi_1["default"].object().allow(null)
});
var setChainOptions = joi_1["default"].object({
    chainId: onboard_common_1.chainIdValidation.required(),
    chainNamespace: onboard_common_1.chainNamespaceValidation,
    wallet: joi_1["default"].string()
});
function validateWallet(data) {
    return (0, onboard_common_1.validate)(wallet, data);
}
exports.validateWallet = validateWallet;
function validateInitOptions(data) {
    return (0, onboard_common_1.validate)(initOptions, data);
}
exports.validateInitOptions = validateInitOptions;
function validateWalletModule(data) {
    return (0, onboard_common_1.validate)(walletModule, data);
}
exports.validateWalletModule = validateWalletModule;
function validateString(str, label) {
    return (0, onboard_common_1.validate)(joi_1["default"].string()
        .required()
        .label(label || 'value'), str);
}
exports.validateString = validateString;
function validateSetChainOptions(data) {
    return (0, onboard_common_1.validate)(setChainOptions, data);
}
exports.validateSetChainOptions = validateSetChainOptions;
function validateWalletInit(data) {
    return (0, onboard_common_1.validate)(walletInit, data);
}
exports.validateWalletInit = validateWalletInit;
